import { render, staticRenderFns } from "./shopOrderGroup.vue?vue&type=template&id=35261476&scoped=true"
import script from "./shopOrderGroup.vue?vue&type=script&lang=js"
export * from "./shopOrderGroup.vue?vue&type=script&lang=js"
import style0 from "./shopOrderGroup.vue?vue&type=style&index=0&id=35261476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35261476",
  null
  
)

export default component.exports